import { render, staticRenderFns } from "./MyQR.vue?vue&type=template&id=01bc0e29&"
import script from "./MyQR.vue?vue&type=script&lang=ts&"
export * from "./MyQR.vue?vue&type=script&lang=ts&"
import style0 from "./MyQR.vue?vue&type=style&index=0&id=01bc0e29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports